/**
 * Login app configuration.
 *
 * Unlike the tenant app, the login app does NOT fetch /configuration
 * from the Graph backend. It is tenant-agnostic.
 *
 * - AUTH_EXTERNAL_URL is always '/auth' (relative). The VirtualServer
 *   routes /auth to the correct auth service per environment.
 * - ENVIRONMENT and VERSION come from Vite build-time CONFIG define.
 * - No TENANT_ID, MAPBOX_TOKEN, or FIREBASE_CONFIG needed.
 */

import type { IAppConfig } from '../shared/Config'

const buildConfig =
  typeof CONFIG !== 'undefined' ? (CONFIG as Partial<IAppConfig>) : {}

const LOGIN_CONFIG: IAppConfig = {
  REDIRECT_CONFIG: {
    isDesktopVersion: true,
    redirects: [],
  },
  BASE_URL: location.host,
  SUBDOMAIN: '',
  ENVIRONMENT: buildConfig.ENVIRONMENT || 'development',
  GOOGLE_ANALYTICS_ID: '',
  MAPBOX_TOKEN: '',
  IPAPI_KEY: '',
  TENANT_ID: '',
  AUTH_EXTERNAL_URL: '/auth',
  VERSION: buildConfig.VERSION || '0.0.0',
  BUILD: buildConfig.BUILD || '',
  REVISION: buildConfig.REVISION || '',
  DEPLOYMENT_VERSION: buildConfig.DEPLOYMENT_VERSION || '',
  READY: Promise.resolve(),
} as IAppConfig

export default LOGIN_CONFIG
